import React from "react";
import { TabView } from "primereact/tabview";
import { TabPanel } from "primereact/tabview";
import { SalesMembers } from "./SalesMembers";
import { GSFDashboard } from "./GSFDashboard";
import { AllOrders } from "./AllOrders";
import { Customers } from "./Customers";
import { EnquiryForm } from "./EnquiryForm";
import { GSFSchemeSelect } from "./GSFSchemeSelect";
import { GSFRefillOrder } from "./GSFRefillOrder";
import { GSFProductMaster } from "./GSFProductMaster";
const saved = localStorage.getItem("user");
const initialValue = JSON.parse(saved);
export const GSFMain = () => {
    return (

        <div className="p-grid crud-demo">
            <div className="p-col-12">
                <div className="card">
                    <TabView>
                        <TabPanel header="Dashboard">
                            <GSFDashboard />
                        </TabPanel>
                        <TabPanel header="Sales Members ( All )">
                            <SalesMembers />
                        </TabPanel>
                        <TabPanel header="Customers ( All )">
                            <Customers />
                        </TabPanel>
                        <TabPanel header="OneTime Orders ( All )">
                            <AllOrders />
                        </TabPanel>
                        <TabPanel header="Refill Orders ( All )">
                            <GSFRefillOrder />
                        </TabPanel>
                        <TabPanel header="Enquiries ( All )">
                            <EnquiryForm />
                        </TabPanel>
                        <TabPanel header="Products ( All )">
                            <GSFProductMaster />
                        </TabPanel>
                        {/* <TabPanel header="Order Place">
                            <GSFSchemeSelect />
                        </TabPanel> */}
                    </TabView>
                </div>
            </div>
        </div>
    )
}